import React, { useState } from 'react';
import { formatPreciseExpiryTime } from '../utils/fileUtils';

interface RetentionTooltipProps {
  uploadedAt: string | number;
  ttl?: number | null; // TTL timestamp (null/undefined = permanent file)
  children: React.ReactNode;
  className?: string;
}

/**
 * Tooltip component that shows precise expiry time on hover
 * Displays text with dotted underline and tooltip with exact days, hours, minutes
 * Shows "Does not expire" for permanent files (no TTL)
 */
export const RetentionTooltip: React.FC<RetentionTooltipProps> = ({ uploadedAt, ttl, children, className = '' }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const isPermanent = ttl === null || ttl === undefined;

  return (
    <span
      className={`relative inline-block ${className}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="cursor-help">
        {children}
      </span>

      {showTooltip && (
        <span className="absolute z-50 px-3 py-2 text-sm bg-gray-900 text-white rounded-lg shadow-lg whitespace-nowrap bottom-full left-1/2 -translate-x-1/2 mb-2 pointer-events-none">
          {isPermanent ? 'Does not expire' : formatPreciseExpiryTime(uploadedAt, ttl)}
          <span className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900" />
        </span>
      )}
    </span>
  );
};
